import tracker from '../../components/tracker/publish'

const EVENT_NAME = 'userevent'
const EVENT_SOURCE = 'control' // mixpanel-forwarder is ignoring any other type of event

export function trackRequestToJoinPrivateGroup (origin: string, groupId: number) {
  tracker.trackEvent(EVENT_NAME, {
    event_source: EVENT_SOURCE,
    type: 'Request to join a private group',
    origin: origin,
    groupId: groupId
  })
}
